<template>
    <section id="theme_search_form">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="theme_search_form_area">
                        <div class="theme_search_form_tabbtn">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="flights-tab" data-bs-toggle="tab"
                                        data-bs-target="#flights" type="button" role="tab" aria-controls="flights"
                                        aria-selected="true">
                                        <i class="fas fa-plane-departure"></i>
                                        {{ $t('Flights') }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="flights" role="tabpanel"
                                aria-labelledby="flights-tab">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="flight_categories_search">
                                            <ul class="nav nav-tabs" role="tablist">
                                                <li v-if="allowed_request_return_flight_only == 1" class="nav-item"
                                                    role="presentation">
                                                    <button class="nav-link" id="oneway-tab" data-bs-toggle="tab"
                                                        data-bs-target="#oneway" type="button" role="tab"
                                                        aria-controls="oneway" aria-selected="false">
                                                        {{ $t('Return only') }}
                                                    </button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link active" id="roundtrip-tab"
                                                        data-bs-toggle="tab" data-bs-target="#roundtrip" type="button"
                                                        role="tab" aria-controls="roundtrip" aria-selected="false">
                                                        {{ $t('Roundtrip') }}
                                                    </button>
                                                </li>
                                                <li v-if="multi_destinations == 1" class="nav-item" role="presentation">
                                                    <button class="nav-link" id="multi_city-tab" data-bs-toggle="tab"
                                                        data-bs-target="#multi_city" type="button" role="tab"
                                                        aria-controls="multi_city" aria-selected="false">
                                                        {{ $t('Multi-City') }}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-content" id="myTabContent1">
                                    <div v-if="allowed_request_return_flight_only == 1" class="tab-pane fade"
                                        id="oneway" role="tabpanel" aria-labelledby="oneway-tab">
                                        <one-way-search-form :arrival_min_date="formatDateSafari(arrival_min_date)"
                                            :arrival_max_date="formatDateSafari(arrival_max_date)" :guest_id="this.$route.query.guest_id"
                                            :companions="companions" :is_self_paying="is_self_paying"
                                            :allowedDegree="allowedDegree" :departure_start_date="formatDateSafari(departure_start_date)"
                                            :departure_end_date="formatDateSafari(departure_end_date)" @search="search">
                                        </one-way-search-form>
                                    </div>
                                    <div class="tab-pane fade active show" id="roundtrip" role="tabpanel"
                                        aria-labelledby="roundtrip-tab">
                                        <roundtrip-search-form :departure_min_date="formatDateSafari(departure_min_date)"
                                            :departure_max_date="formatDateSafari(departure_max_date)"
                                            :arrival_min_date="formatDateSafari(arrival_min_date)" :arrival_max_date="formatDateSafari(arrival_max_date)"
                                            :guest_id="this.$route.query.guest_id" :companions="companions"
                                            :is_self_paying="is_self_paying" :allowedDegree="allowedDegree"
                                            :arrival_start_date="formatDateSafari(arrival_start_date)"
                                            :arrival_end_date="formatDateSafari(arrival_end_date)"
                                            :departure_start_date="formatDateSafari(departure_start_date)"
                                            :departure_end_date="formatDateSafari(departure_end_date)"
                                            :max_free_period_between_arrival_departure="max_free_period_between_arrival_departure"
                                            @search="search">
                                        </roundtrip-search-form>
                                    </div>
                                    <div v-if="multi_destinations == 1" class="tab-pane fade" id="multi_city"
                                        role="tabpanel" aria-labelledby="multi_city-tab">
                                        <multi-city-search-form :departure_min_date="formatDateSafari(departure_min_date)"
                                            :departure_max_date="formatDateSafari(departure_max_date)"
                                            :arrival_min_date="formatDateSafari(arrival_min_date)" :arrival_max_date="formatDateSafari(arrival_max_date)"
                                            :guest_id="this.$route.query.guest_id" :companions="companions"
                                            :is_self_paying="is_self_paying" :allowedDegree="allowedDegree"
                                            :max_free_period_between_arrival_departure="max_free_period_between_arrival_departure"
                                            @search="search">
                                        </multi-city-search-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.allowed_to_choose_need_help_option == 1 && this.can_request_help == true"
                            class="text-center mt-4">
                            <router-link to="/booking-help" class="text-danger">
                                {{ $t('Do you need help booking a flight?') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery';
import { formatStringDate } from '@/utils/dateUtils';
import guestService from '@/services/saudi-cup/guest/guest-service';
import groupService from '@/services/saudi-cup/group/group-service';
import OneWaySearchForm from '@/components/home/OneWaySearchForm.vue';
import RoundtripSearchForm from '@/components/home/RoundtripSearchForm.vue';
import MultiCitySearchForm from '@/components/home/MultiCitySearchForm.vue';
export default {
    name: "Form",
    components: {
        OneWaySearchForm,
        RoundtripSearchForm,
        MultiCitySearchForm
    },
    data() {
        return {
            allowed_companion_numbers: 0,
            max_free_period_between_arrival_departure: 0,
            departure_time_condition: 0,
            arrival_time_condition: 0,
            arrival_start_date: '',
            arrival_end_date: '',
            departure_start_date: '',
            departure_end_date: '',
            allowedDegree: [],
            departure_min_date: new Date(),
            departure_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
            arrival_min_date: new Date(),
            arrival_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
            can_request_help: true,
            companions: [],
            multi_destinations: 1,
            allowed_request_return_flight_only: 1,
            allowed_to_choose_need_help_option: 0,
            max_ticket_price: [],
            is_self_paying: 0,
        };
    },
    methods: {
        formatDateSafari(date) {
            return new Date(String(date).replace(/undefined-undefined-/g, '').replace(/-/g, '/'));
        },
        format_date(inputDate) {
            return formatStringDate(inputDate);
        },
        search(data) {
            localStorage.setItem("searchData", JSON.stringify(data));
            localStorage.setItem("tripType", data['type']);
            this.$router.push('/flight-search-result');
        },
    },
    mounted() {
        $('.pre-loader').show();
        const guest_id = this.$route.query.guest_id;
        const group_id = this.$route.query.group_id;
        const redirect_url = this.$route.query.redirect_url;
        const user_token = this.$route.query.user_token;
        const user_type = this.$route.query.user_type ?? null;
        const order_type = this.$route.query.order_type ?? null;

        localStorage.setItem("home_url", window.location);
        localStorage.setItem("user_token", user_token);
        localStorage.setItem("user_type", user_type);
        localStorage.setItem("order_type", order_type);
        localStorage.removeItem("is_bags_confirmed");
        localStorage.removeItem('is_package_confirmed');

        if (guest_id) {
            localStorage.removeItem('group_id');
            guestService.guest_by_encrypted_id(guest_id).then(response => {
                const data = response.data.data, guest = data.guest, policy = data.policy, packages = data.packages;
                localStorage.setItem("essential_guest", guest.essential_guest);
                if (guest.data_status == "Complete" &&
                    !guest.flight &&
                    !guest.coming_without_help &&
                    !guest.self_paying_airline &&
                    (guest.guest_need_help_flight.length == 0 || user_type == null)
                ) {
                    localStorage.setItem("redirect_url", redirect_url);
                    localStorage.setItem("user_token", user_token);
                    localStorage.setItem("guest_data", JSON.stringify(data));

                    localStorage.setItem("guest_id", guest_id);
                    localStorage.setItem("allowed_to_request_hotel_reservation", policy.allowed_to_book_hotel);


                    if (guest.ticket_price?.length > 0) {
                        this.max_ticket_price = guest.ticket_price;
                    }
                    localStorage.setItem("allowed_to_make_exception", policy.request_trip_higher_than_the_permitted_price);
                    localStorage.setItem("max_ticket_price", JSON.stringify(this.max_ticket_price));

                    var allowedDegree = policy.degree_of_reservation['data'];
                    var degrees = [];
                    allowedDegree.forEach(element => {
                        degrees.push(element.value);
                    });
                    this.allowedDegree = degrees;
                    localStorage.setItem("allowed_degree", JSON.stringify(degrees));

                    this.allowed_to_choose_need_help_option = policy.allowed_to_request_help;
                    localStorage.setItem("allowed_to_choose_need_help_option", this.allowed_to_choose_need_help_option);

                    this.allowed_companion_numbers = policy.companion_count;
                    this.companions = guest.companions;
                    localStorage.setItem("companions", JSON.stringify(guest.companions));

                    if (guest.companions.length == 0) {
                        this.allowed_companion_numbers = 0;
                    }
                    guest.companions.forEach(element => {
                        if (element.flight) {
                            this.allowed_companion_numbers -= 1;
                        }
                    });

                    this.max_free_period_between_arrival_departure = policy.allowed_duration_between_arrive_and_departure_date;
                    localStorage.setItem("allowed_companion_numbers", this.allowed_companion_numbers);
                    localStorage.setItem("max_free_period_between_arrival_departure", this.max_free_period_between_arrival_departure);

                    var flight_type = policy.flight_type['data'];
                    var types = [];
                    flight_type.forEach(element => {
                        types.push(element.value);
                    });
                    this.multi_destinations = types.includes('multi-destination') ? 1 : 0;
                    localStorage.setItem("multi_destinations", this.multi_destinations);

                    this.allowed_request_return_flight_only = types.includes('one-way') ? 1 : 0;
                    localStorage.setItem("allowed_request_return_flight_only", this.allowed_request_return_flight_only);


                    this.departure_start_date = policy.back_from_riyadh_from_date;
                    this.departure_end_date = policy.back_from_riyadh_to_date;
                    localStorage.setItem("departure_start_date", this.departure_start_date);
                    localStorage.setItem("departure_end_date", this.departure_end_date);

                    this.arrival_min_date = this.format_date(this.departure_start_date);
                    this.arrival_max_date = this.format_date(this.departure_end_date);


                    this.arrival_start_date = policy.departure_to_riyadh_from_date;
                    this.arrival_end_date = policy.departure_to_riyadh_to_date;
                    localStorage.setItem("arrival_start_date", this.arrival_start_date);
                    localStorage.setItem("arrival_end_date", this.arrival_end_date);

                    this.departure_min_date = this.format_date(this.arrival_start_date);
                    this.departure_max_date = this.format_date(this.arrival_end_date);

                    if (guest.need_flight_helping) {
                        this.can_request_help = false;
                    }
                    localStorage.setItem("can_request_help", this.can_request_help);

                    if (policy.for_guests_on_their_own_account == 1) {
                        this.is_self_paying = 1;
                        localStorage.setItem("is_self_paying", 1);
                    } else {
                        this.is_self_paying = 0;
                        localStorage.setItem("is_self_paying", 0);
                    }
                    localStorage.setItem("allowed_to_request_additional_weight", policy.allowed_to_request_additional_weight);
                    localStorage.setItem("allow_sitemap", policy.allow_sitemap);

                    var need_flights = packages.some(element => element.service.service_name_en === 'Flights');
                    if (!need_flights && this.is_self_paying == 1) {
                        localStorage.setItem("packages", JSON.stringify(packages));
                        this.$router.replace('/no-flights-confirmation');
                    }
                } else if (guest.guest_need_help_flight.length != 0) {
                    localStorage.setItem("guest_data", JSON.stringify(data));
                    this.$router.replace('/booking-help-details');
                } else if (guest.flight) {
                    localStorage.setItem("guest_data", JSON.stringify(data));
                    this.$router.replace('/booking-details');
                } else {
                    this.$router.replace('/error');
                    localStorage.clear();
                }
                $('.pre-loader').hide();
            });
        } else {
            localStorage.removeItem('guest_id');
            localStorage.setItem("essential_guest", 1);
            groupService.get_flight_group_id(group_id).then((response) => {
                const data = response.data.data,
                    guests = data.guests,
                    policy = data.policy;

                localStorage.setItem("redirect_url", redirect_url);
                localStorage.setItem("user_token", user_token);
                localStorage.setItem("guest_data", JSON.stringify(data));

                localStorage.setItem("group_id", group_id);
                localStorage.setItem("allowed_to_request_hotel_reservation", policy.allowed_to_book_hotel);


                if (guests.ticket_prices?.length > 0) {
                    this.max_ticket_price = guests.ticket_prices;
                }

                localStorage.setItem("allowed_to_make_exception", policy.request_trip_higher_than_the_permitted_price);
                localStorage.setItem("max_ticket_price", JSON.stringify(this.max_ticket_price));

                var allowedDegree = policy.degree_of_reservation['data'];
                var degrees = [];
                allowedDegree.forEach(element => {
                    degrees.push(element.value);
                });
                this.allowedDegree = degrees;
                localStorage.setItem("allowed_degree", JSON.stringify(degrees));

                this.allowed_to_choose_need_help_option = policy.allowed_to_request_help;
                localStorage.setItem("allowed_to_choose_need_help_option", this.allowed_to_choose_need_help_option);


                this.allowed_companion_numbers = guests.members.length;
                this.companions = guests.members;

                localStorage.setItem("companions", JSON.stringify(this.companions));

                this.max_free_period_between_arrival_departure = policy.allowed_duration_between_arrive_and_departure_date;
                localStorage.setItem("allowed_companion_numbers", this.allowed_companion_numbers);
                localStorage.setItem("max_free_period_between_arrival_departure", this.max_free_period_between_arrival_departure);

                var flight_type = policy.flight_type['data'];
                var types = [];
                flight_type.forEach(element => {
                    types.push(element.value);
                });
                this.multi_destinations = types.includes('multi-destination') ? 1 : 0;
                localStorage.setItem("multi_destinations", this.multi_destinations);

                this.allowed_request_return_flight_only = types.includes('one-way') ? 1 : 0;
                localStorage.setItem("allowed_request_return_flight_only", this.allowed_request_return_flight_only);


                this.departure_start_date = policy.back_from_riyadh_from_date;
                this.departure_end_date = policy.back_from_riyadh_to_date;
                localStorage.setItem("departure_start_date", this.departure_start_date);
                localStorage.setItem("departure_end_date", this.departure_end_date);

                this.arrival_min_date = this.format_date(this.departure_start_date);
                this.arrival_max_date = this.format_date(this.departure_end_date);


                this.arrival_start_date = policy.departure_to_riyadh_from_date;
                this.arrival_end_date = policy.departure_to_riyadh_to_date;
                localStorage.setItem("arrival_start_date", this.arrival_start_date);
                localStorage.setItem("arrival_end_date", this.arrival_end_date);

                this.departure_min_date = this.format_date(this.arrival_start_date);
                this.departure_max_date = this.format_date(this.arrival_end_date);

                localStorage.setItem("can_request_help", this.can_request_help);

                localStorage.setItem("allowed_to_request_additional_weight", policy.allowed_to_request_additional_weight);
                localStorage.setItem("allow_sitemap", policy.allow_sitemap);
                if (policy.for_guests_on_their_own_account == 1) {
                    this.is_self_paying = 1;
                    localStorage.setItem("is_self_paying", 1);
                } else {
                    this.is_self_paying = 0;
                    localStorage.setItem("is_self_paying", 0);
                }
                $('.pre-loader').hide();
            }).catch(error => {
                console.log(error);
                $('.pre-loader').hide();
                this.$router.replace(`/error`);
            });
        }
    }
};
</script>
<style scoped>
@media (min-width: 1200px){
  .container, .container-lg, .container-md, .container-sm, .container-xl {
      max-width: 1290px;
  }
}
</style>
<style lang="scss">
.ui-id-1,
.ui-id-2 {
  max-height: calc(100vh - 335px);
  overflow-y: auto;
  border: 1px solid #f5eefd;
  background: #fff;
  color: #333;
  cursor: default;
  list-style: none;
  padding: 0;
  display: block;
  outline: 0;
  margin: 0px 12px;
  border-radius: 8px;

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #e3e3e3;
      border-radius: 25px;
  }

  &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 25px;
  }

  &::-webkit-scrollbar-thumb:hover {
      background: var(--main-color);
  }
}

.ui-autocomplete {
  position: absolute;
  top: 0;
  left: 0;
  cursor: default;
}

.ui-menu .ui-menu-item.fl-route-list.ui-autocomplete-category {
  pointer-events: none;
  opacity: 1 !important;
}

.fl-route-list {
  border: 1px solid transparent;
  border-bottom-color: #f0eeee;
  cursor: pointer;
}

.fl-route-list.ui-autocomplete-category .fl-routes,
.fl-route-list.ui-autocomplete-category .fl-routes:hover {
  pointer-events: none;
  color: var(--main-color);
  ;
  cursor: pointer;
}

.fl-routes {
  display: block;
  outline: 0 !important;
  text-decoration: none !important;
  padding: 10px !important;
  border-color: transparent !important;
  border-bottom-color: #f0eeee;
  position: relative;
  white-space: normal;
}

.inline-block {
  display: inline-block;
}

.fl-loc {
  font-weight: 600;
}

.fl-routes .fl-country {
  display: block;
  font-size: 12px;
  margin-top: 3px;
  color: #b3b3b3;
}

.rtl .pull-right {
  float: left !important;
}

.fl-routes .fl-route-code {
  font-size: 18px;
  margin: 0;
  margin-top: 5px;
  font-weight: 700;
}
.dp__input_readonly {
  padding-right: 40px !important;
}

input.chk-cabin {
  display: none;
}

.label-select-btn:has(input:checked) {
  background: var(--main-color);
  color: var(--white-color);
}

.label-select-btn label {
  width: 100%;
  text-align: initial;
}
.dp__range_end, .dp__range_start, .dp__active_date {
  background: var(--main-color) !important;
}
</style>